export enum UserType {
  VIEWER = 'viewer',
  STREAMER = 'streamer',
}

export const USER_COLORS = [
  '#ee2ec2',
  '#b77afb',
  '#29a4ff',
  '#00c1d5',
  '#02c166',
  '#6aad00',
  '#ed8500',
  '#e65300',
]

export const MAX_BIO_LENGTH = 100
